import { put, call, takeLatest } from 'redux-saga/effects';
import { base_url, endpoints } from '../../../constants';
import { AxiosService } from '../../../services';
import { actionTypes } from '../../../types';
import { optUGCCampaignFailure, optUGCCampaignSuccess } from '../../actions/InfluencerCampaignActions/optUGCCampaignAction';

function* optUGCCampaign({ payload, callback }) {
    try {
        const response = yield call(AxiosService, {
            method: 'post',
            base_url: base_url,
            endPoint: endpoints.optUGCCampaign,
            payload: payload,
            isAuth: true,
        });
        console.log('====================================');
        console.log("OPT_UGC_CAMPAIGN_SUCCESS status :", response.data.status);
        console.log("OPT_UGC_CAMPAIGN_SUCCESS data :", response.data.response);
        console.log("OPT_UGC_CAMPAIGN_SUCCESS message :", response.data.message);
        console.log('====================================');
        yield put(
            optUGCCampaignSuccess({
                status: response?.data?.status,
                response: response?.data?.response,
                message: response?.data?.message
            })
        );
        if (callback) {
            callback(
                response?.data?.status,
                response?.data?.response,
                response?.data?.message
            ); // Pass the response data to the callback
        }
    } catch (error) {
        console.log('====================================');
        console.log("OPT_UGC_CAMPAIGN_FAILURE status :", error?.response?.status);
        console.log("OPT_UGC_CAMPAIGN_FAILURE data:", error?.response?.data);
        console.log("OPT_UGC_CAMPAIGN_FAILURE error :", error);
        console.log('====================================');
        yield put(optUGCCampaignFailure({
            status: error?.response?.data?.status,
            response: {},
            message: error?.response?.data?.message
        }));
    }
}

function* optUGCCampaignSaga() {
    yield takeLatest(actionTypes.OPT_UGC_CAMPAIGN_REQUEST, optUGCCampaign);
}

export default optUGCCampaignSaga;
